import { render, staticRenderFns } from "./DocumentDetailView.vue?vue&type=template&id=63e5dca7&scoped=true"
import script from "./DocumentDetailView.vue?vue&type=script&lang=js"
export * from "./DocumentDetailView.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailView.vue?vue&type=style&index=0&id=63e5dca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5dca7",
  null
  
)

export default component.exports